import React, { useState } from 'react';
import { MsGraphContext, MsGraphProps } from '../contexts/MsGraphContext';
import { useGetDriveItemFromUrl } from '../hooks/msGraph/useGetDriveItemFromUrl';

interface MsGraphProviderProps {
  children?: React.ReactNode;
}

export const MsGraphProvider: React.FC<MsGraphProviderProps> = ({ children }) => {
  const [msGraphProps, setMsGraphProps] = useState<Partial<MsGraphProps>>({});
  const { data: driveItem, isLoading: isDriveItemLoading } = useGetDriveItemFromUrl(msGraphProps?.fileUrl);

  return (
    <MsGraphContext.Provider
      value={{
        msGraphProps,
        setMsGraphProps,
        driveItem,
        isDriveItemLoading
      }}
    >
      {children}
    </MsGraphContext.Provider>
  );
};
